import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'

export function useIsCurrentUser(rowId: string) {
	const { data: currentUser } = useQueryProfile()
	return currentUser?.id === rowId
}
